module.exports = __webpack_public_path__ + "img/NecroticBone.166f8984.png";